<template>
    <div ref="chart" style="width:100%;height:100%;"></div>
</template>

<script>
export default {
    name: "Bar",
    props: {id: Number, wdSize: Object},
    computed: {},
    watch: {
        id() {
            this.setData()
        },
        wdSize(n, o) {
            if (this.chart) {
                this.chart.resize();
                setTimeout(() => {
                    this.chart.resize();
                }, 10)
            }
        }
    },
    // created() {
    //
    // },
    data() {
        return {
            chart: null,
            option: {
                title: {
                    text: '满意度分布',
                    subtext: 'Satisfaction distribution',
                    left: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 'bold',
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    //修改X轴文字颜色
                    axisLabel: {
                        color: '#fff',
                        fontSize: 14,
                    },
                },
                yAxis: {
                    type: 'value',
                    //修改Y轴文字颜色
                    axisLabel: {
                        color: '#fff',
                        fontSize: 14,
                    },
                },
                series: [
                    {
                        data: [],
                        type: 'bar'
                    }
                ]
            },
        }
    },
    methods: {
        resize() {
            // if (this.chart) {
            this.chart.resize()
            // }
        },
        setData() {

            this.$axios({
                method: 'get',
                url: '/getMyd?id=' + this.id,
                data: {}
            }).then(r => {
                let data = r.data
                this.option.xAxis.data = data.x
                this.option.series[0].data = data.y
                this.chart.setOption(this.option)
            })
           


        }

    },
    mounted() {
        this.$nextTick(() => {
            this.chart = this.$echarts.init(this.$refs.chart, '');
            this.setData()
        })
    },

}
</script>

<style scoped>
</style>